import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-snaptrix-gray-900 text-snaptrix-gray-400 py-8 md:py-12 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-sm md:text-base">
          © {currentYear} Snaptrix. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
